var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.layers.length)?_c('dropdown-button',{attrs:{"mapgl":_vm.mapgl,"module":_vm.module,"layer-id":_vm.id,"icon":"ksodd-map","title":"Ортофотопланы","layers":_vm.layers,"add-handler":_vm.addHandler,"layers-ids":_vm.layersIds}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }